import 'videojs-watermark';
import logo from '../assets/bnnvara-logo';

export default {
  mapPropStateToOptions: {
    image: logo,
    position: 'top-left',
    fadeTime: 2000,
    url: 'https://www.bnnvara.nl',
  },
};
